module.exports = {
      id: "spinner-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "static/media/sprite.09d5fc87.svg#spinner-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/spinner.svg
// module id = 316
// module chunks = 0